module.exports = __webpack_public_path__ + "static/title.d9d2f0ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/debugger/img/p2/title.png
// module id = 564
// module chunks = 270304712061374